import React from 'react';
import { FormattedMessage } from 'react-intl';
import './page403.scss';

const Page403 = () => (
    <div className="messages-container">
        <FormattedMessage id="403.page.message" defaultMessage="Vous n'avez pas le droit d'accèder à cette page." />
        <FormattedMessage
            id="403.page.instructions"
            defaultMessage="Si vous pensez que ceci est une erreur, veillez essayer de vous déconnecter et reconnecter."
        />
    </div>
);

Page403.propTypes = {};

export { Page403 };
